import { ICreateDevice, IEditDevice, IGetPaginatedDevices, IDeviceNotificationsData } from 'types';
import {
	serviceGetDeviceInfo,
	serviceCreateDevice,
	serviceUpdateDevice,
	serviceGetPaginatedDevices,
	serviceDeleteDevice,
	servicePushDeviceNotifications,
} from 'services/api/devices';
import { createAppErrorMessage } from 'utils/helpers';

const getDeviceInfo = async (deviceID: string) => {
	try {
		const response = await serviceGetDeviceInfo(deviceID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const createDevice = async (data: ICreateDevice) => {
	try {
		await serviceCreateDevice(data);
	} catch (err) {
		throw err;
	}
};

const editDevice = async (data: IEditDevice) => {
	try {
		await serviceUpdateDevice(data);
	} catch (err) {
		throw err;
	}
};

const getPaginatedDevices = async (args: IGetPaginatedDevices) => {
	try {
		const response = await serviceGetPaginatedDevices(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const deleteDevice = async (deviceID: string) => {
	try {
		await serviceDeleteDevice(deviceID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingDevice');
		throw new Error(errorMessage);
	}
};

const pushDeviceNotifications = async (hardwareID: string, data: IDeviceNotificationsData) => {
	try {
		await servicePushDeviceNotifications(hardwareID, data);
	} catch (err) {
		throw err;
	}
};

export { getDeviceInfo, createDevice, editDevice, getPaginatedDevices, deleteDevice, pushDeviceNotifications };
